module.exports = __webpack_public_path__ + "static/GorditaMedium-Italic-e4daf64b21cd3d41ac3ad5b045193154.woff";